// src/routes/AppRouter.js

import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

import Login from "../pages/login/login";
import Dashboard from "../pages/dashboard/dashboard";
import LoadingScreen from "../components/LoadScreen";

import Empresas from "../pages/admin/empresas/Empresas";
import Clinicas from "../pages/admin/clinicas/Clinicas";
import Convenios from "../pages/admin/convenios/Convenios";
import Pacientes from "../pages/admin/pacientes/Pacientes";
import Prestadores from "../pages/admin/prestadores/Prestadores";
import Funcionarios from "../pages/admin/funcionarios/Funcionarios";
import Especialidades from "../pages/admin/especialidades/Especialidades";
import Usuarios from "../pages/admin/usuarios/Usuarios";
import Perfis from "../pages/admin/perfis/Perfis";

function PrivateRoute({ children }) {
  const { authenticated, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  return authenticated ? children : <Navigate to="/login" replace />;
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route element={<PrivateRoute><Dashboard /></PrivateRoute>}>
        <Route path="/dashboard" element={<div />} />

        <Route path="/admin/empresas" element={<Empresas />} />
        <Route path="/admin/clinicas" element={<Clinicas />} />
        <Route path="/admin/convenios" element={<Convenios />} />
        <Route path="/admin/pacientes" element={<Pacientes />} />
        <Route path="/admin/prestadores" element={<Prestadores />} />
        <Route path="/admin/funcionarios" element={<Funcionarios />} />
        <Route path="/admin/especialidades" element={<Especialidades />} />
        <Route path="/admin/usuarios" element={<Usuarios />} />
        <Route path="/admin/perfis" element={<Perfis />} />
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}